import { ref } from 'vue';
import { defineStore } from 'pinia';
import { parseJwt } from '@/common/services/jwt.service';
import ActionCableService from '@/common/services/action_cable.service';

export const useUserStore = defineStore('users', () => {
  const currentUser = ref(parseJwt());

  const actionItems = ref({
    subscription: null,
    count: 0,
  });

  const donationActionItems = ref({
    subscription: null,
    count: 0,
  });

  function setupActionItemSubscription() {
    actionItems.value.subscription = ActionCableService.subscribe('ActionItemsChannel', currentUser.value.id, {
      received(packet) {
        if (packet.count !== undefined) {
          actionItems.value.count = packet.count;
        }
        console.debug('Socket', 'received', packet);
      },
      connected() {
        console.debug('Socket', 'connected ActionItemsChannel');
      },
      disconnected() {
        console.debug('Socket', 'disconnected');
      },
      rejected() {
        console.debug('Socket', 'rejected');
      },
    });
  }

  function setupDonationActionItemSubscription() {
    donationActionItems.value.subscription = ActionCableService.subscribe('DonationActionItemsChannel', currentUser.value.id, {
      received(packet) {
        if (packet.count !== undefined) {
          donationActionItems.value.count = packet.count;
        }
        console.debug('Socket', 'received', packet);
      },
      connected() {
        console.debug('Socket', 'connected DonationActionItemsChannel');
      },
      disconnected() {
        console.debug('Socket', 'disconnected');
      },
      rejected() {
        console.debug('Socket', 'rejected');
      },
    });
  }

  return {
    currentUser,
    actionItems,
    donationActionItems,
    setupActionItemSubscription,
    setupDonationActionItemSubscription,
  };
});
